// extracted by mini-css-extract-plugin
export var standaloneTable = "_fx-0";
export var withExtraHeader = "_fx-1";